import './TeamSquare.css'
import classNames from "classnames";
import { useState } from 'react';

const TeamSquare = ({ team, hidden = false }) => {
    const [imageLoaded, setImageLoaded] = useState(false);
    const [imageError, setImageError] = useState(false);

    // Modo 412: el requisito de esta fila/columna todavía no se reveló (nadie clickeó
    // ninguna casilla que lo cruce). No hace falta resolver ninguna imagen — placeholder fijo.
    if (hidden) {
        return (
            <div className="team--hidden">
                <span className="team-hidden-icon">🔒</span>
            </div>
        );
    }

    let teamClass = classNames({
        [`team--${team}`]: team !== null,
    });

    let imgClub;
    let context;

    try {
        context = require.context('../../img/teams', false, /\.jpg$/);
        imgClub = context(`./${team}.jpg`);
    } catch (err) {
        try {
            context = require.context('../../img/country', false, /\.jpg$/);
            imgClub = context(`./${team}.jpg`);
        } catch (err) {
            try {
                context = require.context('../../img/years', false, /\.jpg$/);
                imgClub = context(`./${team}.jpg`);
            } catch (err) {
                try {
                    context = require.context('../../img/achievements', false, /\.jpg$/);
                    imgClub = context(`./${team}.jpg`);
                } catch (err) {
                    try {
                        context = require.context('../../img/dt', false, /\.jpg$/);
                        imgClub = context(`./${team}.jpg`);
                    }
                    catch (err) {
                        try {
                            context = require.context('../../img/positions', false, /\.jpg$/);
                            imgClub = context(`./${team}.jpg`);
                        }
                        catch (err) {
                            console.log(err);
                        }
                    }
                }
            }
        }
    }

    return (
        <div className={teamClass}>
            {!imageLoaded && !imageError && (
                <div className="team-spinner">
                    <div className="spinner-circle"></div>
                </div>
            )}
            <img 
                src={imgClub} 
                alt={team} 
                className={`team ${imageLoaded ? 'loaded' : 'loading'}`}
                onLoad={() => setImageLoaded(true)}
                onError={() => setImageError(true)}
                style={{ display: imageLoaded ? 'block' : 'none' }}
            />
        </div>
    )
}

export default TeamSquare;